import { Spacer } from "../Layout/Layout";
import { ManualSync } from "./ManualSync";
import useUser from "../../core/user/useUser";
import useTranslations from "../../core/i18n/useTranslations";

import styles from "../../pages/Objects/ObjectGeneral/ObjectGeneral.module.css";

export interface ManualSyncTableProps {
  syncStatus?: string;
  latestSyncAttempt?: string;
  lastSync?: string;
}

export const ManualSyncWrapper = ({
  clusterData,
  externalSettingData,
  refetchFunc,
}: {
  clusterData: ManualSyncTableProps;
  externalSettingData?: ManualSyncTableProps;
  refetchFunc: () => Promise<void>;
}) => {
  const t = useTranslations();
  const { config } = useUser();

  const showClusterSync = config?.show.includes("LastClusterSync");
  const showExternalSync =
    externalSettingData &&
    externalSettingData.syncStatus !== "NO_INTEGRATION_DEFINED";

  if (!showClusterSync && !showExternalSync) {
    return null;
  }

  return (
    <div className={styles.ObjectBasicContainer}>
      <h2>{t("Objects:manual_sync_header")}</h2>
      <p>{t("Objects:manual_sync_description")}</p>

      <Spacer size={20} />

      {showClusterSync && (
        <ManualSync
          buttonHidden
          title={t("Objects:sync_with_cluster")}
          data={clusterData}
          fetchFunc={refetchFunc}
        />
      )}
      {showExternalSync && (
        <ManualSync
          buttonHidden={false}
          title={t("Objects:sync_with_external_system")}
          data={externalSettingData}
          fetchFunc={refetchFunc}
        />
      )}
    </div>
  );
};
